module.exports = __webpack_public_path__ + "static/media/progress.897fbf4a.webp";